<template>
  <header class="bg-dark-navy text-white p-4 flex justify-between items-center">
    <div class="flex items-center space-x-4">
      <span class="text-lg font-bold">오토 트레이딩 시스템</span>
      <span class="text-xs">{{ currentDate }}</span>
    </div>

    <div class="flex space-x-4" v-if="isLoginPage">
      <button
        class="bg-gray-700 px-4 py-2 rounded relative"
        @mousedown.prevent="mouseDownHeader"
        :ref="header"
      >
        설정
        <ul v-if="state" class="dropdown-item">
          <li
            v-for="dropdown in dropdownList"
            :key="'dw_' + dropdown.index"
            class="hover:bg-gray-500 py-1"
            @mousedown.prevent="dropdown.callback"
          >
            {{ dropdown.label }}
          </li>
        </ul>
      </button>
    </div>
  </header>

  <MemberKeyModal v-if="isOpen" @modal-close="isOpen = false" />
</template>

<script>
import { storeName } from "@/global/variable";
import router from "@/routes";
import { ref } from "vue";
import { mapMutations } from "vuex";
import MemberKeyModal from "./modal/MemberKeyModal.vue";

export default {
  name: "MainHeader",
  components: { MemberKeyModal },
  props: {
    isLoginPage: Boolean,
  },
  setup() {
    const state = ref(false);
    const header = ref(null);
    return {
      state,
      header,
    };
  },
  data() {
    return {
      // 현재 날짜 표시
      currentDate: new Date().toLocaleDateString("ko-KR"),

      dropdownList: [
        { index: 0, label: "로그아웃", callback: () => this.onClickLogout() },
        {
          index: 1,
          label: "api/secretKey 설정",
          callback: () => (this.isOpen = true),
        },
      ],
      isOpen: false,
    };
  },
  computed: {},
  methods: {
    ...mapMutations(storeName.user, ["MU_RESET_AUTH"]),

    toggleListener(active) {
      active
        ? window.addEventListener("mousedown", this.mouseDownOutSide)
        : window.removeEventListener("mousedown", this.mouseDownOutSide);
    },
    mouseDownHeader() {
      this.toggleListener((this.state = !this.state));
    },
    mouseDownOutSide(e) {
      const isOutside = this.header && !this.header.contains(e.target);

      if (isOutside) this.toggleListener((this.state = false));
    },
    onClickLogout() {
      if (!confirm("로그아웃 하시겠습니까?")) return;

      // 로컬 스토리지 삭제
      localStorage.removeItem("user");
      localStorage.removeItem("userRefresh");

      // 유저 인증 초기화
      this.MU_RESET_AUTH();

      alert("로그아웃 되었습니다. 로그인 페이지로 이동합니다.");

      router.push("/auth/login");

      // 로그인 페이지로 이동

      // TODO : 로그아웃 로직
    },
  },
};
</script>

<style scoped>
.bg-dark-navy {
  background-color: #1b263b;
}
.dropdown-item {
  position: absolute;
  top: 45px;

  right: 0;
  bottom: 0;
  width: 200px;
  height: 100px;
  padding: 0.5rem;
  background-color: #374151;
  color: #ffffff;
  box-shadow: #000000 0px 0px 10px;
  z-index: 11111;
  border-radius: 0.5rem;
  &::after {
    content: " ";
    /* width: 10px; */
    /* height: 10px; */

    position: absolute;
    top: -10px;
    right: 10px;
    border-width: 5px;
    border-color: transparent transparent #374151 transparent;
  }

  > li {
    border-bottom: 1px solid #49515d;
  }
}
</style>
